<div class="welcome container-fluid">
  <img src="./../../../assets/images/yes7-ticket-logo.png" alt="logotipo welcome yes 7 tickets" />
  <div class="welcome__container">
    <h1 class="welcome__title">Bem-vindo à nossa plataforma!</h1>
    <p class="welcome__text">Estamos felizes em tê-lo aqui.</p>
    <app-button class="welcome__button" (click)="goToHome()">Ir para página inicial</app-button>
  </div>
</div>
